module.exports = __webpack_public_path__ + "static/media/icon_mysql.0d3e129b.svg";